import { createContext, useContext, type ReactNode } from "react";

export interface CarrierFieldValue {
  /**
   * Carrier slug → short reason it cannot be picked, e.g. "Pending contract".
   * The reason is shown on the option and as its tooltip.
   */
  unavailable: Record<string, string>;
}

const EMPTY: CarrierFieldValue = { unavailable: {} };

const CarrierFieldContext = createContext<CarrierFieldValue>(EMPTY);

/** Carries carrier-specific state to the carrier picker without prop drilling. */
export function CarrierFieldProvider({
  value,
  children,
}: {
  value: CarrierFieldValue;
  children: ReactNode;
}) {
  return <CarrierFieldContext.Provider value={value}>{children}</CarrierFieldContext.Provider>;
}

export function useCarrierField(): CarrierFieldValue {
  return useContext(CarrierFieldContext);
}
